import { createRouter, createWebHistory } from "vue-router";

// Gaurds
import { registerGuard } from "./Guard";
import { registerTitleToPage } from "./Pages";

// pages
import DashboardPage from "../pages/DashboardPage.vue";
import RedirectToVm from "../pages/RedirectToVm.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import NotFound from "../pages/NotFound.vue";
import NotAuth from "../pages/NotAuth.vue";
import MultiApps from "../pages/MultiApps.vue";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    meta: {
      requiresAuth: true,
      title: "Eirady",
    },
    component: DashboardPage,
  },
  {
    path: "/redirect",
    name: "RedirectToVmRoute",
    meta: {
      requiresAuth: true,
      title: "Eirady",
    },
    component: RedirectToVm,
  },
  {
    path: "/logout",
    name: "Logout",
    component: LogoutPage,
  },
  {
    path: "/not-found",
    name: "NotFound",
    meta: { title: "Eirady - Not Found" },
    component: NotFound,
  },
  {
    path: "/not-auth",
    name: "NotAuth",
    meta: { requiresAuth: true, title: "Eirady - Not Auth" },
    component: NotAuth,
  },
  {
    path: "/multi-apps",
    name: "MultiApps",
    meta: { title: "Eirady - Not Auth" },
    component: MultiApps,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/not-found",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

registerGuard(router);
registerTitleToPage(router);

export default router;
